// Read-only subscription summary card for the schools/families drill-in.
// docs/replan-v2.md (admin console, slice 2). Staff chrome — the plan name is a
// translation key (admin has no i18n runtime), shown raw for reference.

import { Badge } from '@fajrarabi/ui';

import type { OwnerSubscription } from '~/lib/admin';

export function SubscriptionCard({
  subscription,
  className,
}: {
  subscription: OwnerSubscription | null;
  className?: string;
}) {
  return (
    <section
      className={`rounded-2xl border border-burgundy-500/10 bg-white p-5 ${className ?? ''}`}
    >
      <p className="text-xs uppercase tracking-wider text-ink-500">Subscription</p>
      {!subscription ? (
        <p className="mt-1 text-sm text-ink-500">No subscription.</p>
      ) : (
        <div className="mt-2 flex flex-wrap items-center gap-3 text-sm text-ink-700">
          <Badge tone={subscription.status === 'active' ? 'success' : 'neutral'}>
            {subscription.status}
          </Badge>
          <span>
            {subscription.currency} · {subscription.interval}
          </span>
          <code className="text-xs text-ink-500">{subscription.planNameKey}</code>
          {subscription.currentPeriodEnd && (
            <span className="text-ink-500">
              renews {subscription.currentPeriodEnd.slice(0, 10)}
            </span>
          )}
        </div>
      )}
    </section>
  );
}
